var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.updateSize),expression:"updateSize"}],staticClass:"map-container"},[_c('map-picker',{ref:"map",attrs:{"uiid":"map_picker","maptype":"picker"},model:{value:(_vm.latLng),callback:function ($$v) {_vm.latLng=$$v},expression:"latLng"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }